define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/core/Key",
	"csi/table/Widget",
	"csi/xml",
	"SiteAdmin/Locale"
], function(declare, _, csi, Key, Table, xml, Locale) {

	return declare(Table, {
		// String: url of EnumValue for which editing DependsOn
		dependsOnValue: csi.EMPTY_URL,

		// String: name of DependsOn EnumList
		//dependsOnEnum: null,

		canGroup: function() {
			// summary: grouping not applicable here
			return false;
		},

		onDependsOnEnumValue: function(/*Object*/item) {
			// summary: reference SiteAdmin/Locale/Enum
			console.assert(!!this.dependsOnEnum);
			var enumValue = xml.enumCreate(this.dependsOnEnum, item.Name);
			item.Name = Locale.getConfigResolver().getEnumName(enumValue) || Locale.getBaseConfigResolver().getEnumName(enumValue);
		},

		setViewNode: function(/*Node*/node, /*Boolean*/bSaveSelections) {
			// summary: update dependsOnEnum before rendering table
			const dependsOn = this.cacheView.get(node?.DependsOn);
			this.set("dependsOnValue", csi.EMPTY_URL);
			this.set("dependsOnEnum", dependsOn?.$Name);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Hide the Composition column if the material composition feature flag is turned off
		 */
		onViewResolveKeysToSkip(skipSet) {
			const viewNode = this.getViewNode();
			const dependsOn = this.cacheView.get(viewNode?.DependsOn);
			if (!dependsOn) {
				skipSet.add(Key.untypedKeyFromParts({
					id: "DependsOn",
				}));
				skipSet.add(Key.untypedKeyFromParts({
					name: "EnumValueDependent",
				}));
			}
		},

		onViewResults: function(qr, resultNodes) {
			this.inherited(arguments);
			this.toolbarNode?.enablePlugins();
		}
	});
});